module.exports = __webpack_public_path__ + "static/media/MM.19aee41e.png";